import { ComponentProps } from 'react';

import BlackIcon from '@/shared/assets/icons/question_black.png';
import WhiteIcon from '@/shared/assets/icons/question_white.png';

import { useDarkModeStore } from '@/hooks/states/useDarkMode';

import Image from '@/components/elements/Image';

type Props = ComponentProps<'img'>;

const QuestionIcon = (props: Props) => {
  const { isDark } = useDarkModeStore();

  return <Image src={isDark ? WhiteIcon : BlackIcon} {...props} />;
};

export default QuestionIcon;
